import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { AppMembershipRoleEnum } from 'src/graphql/schema';

import { roleOptions, useAppMembershipsManagement } from '../model';

const PendingRoleCell = ({ id, role }: { id: string; role: string }) => {
  const { updatePendingMemberRole } = useAppMembershipsManagement();

  const onUpdate = (role: AppMembershipRoleEnum) => updatePendingMemberRole(id, role);

  return (
    <Select value={role} onValueChange={onUpdate}>
      <SelectTrigger variant="ghost" justify="end" className="px-0">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {roleOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default PendingRoleCell;
